module.exports = __webpack_public_path__ + "static/media/DSC02330.3cfc0f2b.jpg";